module.exports = __webpack_public_path__ + "static/media/hot12.cabac2bf.jpg";